import { RENAL_BLADDER_FINDINGS } from "../groups/bladder";
import { KIDNEY_FINDINGS, RENAL_IMPRESSION } from "../groups/renal";
import { option, type UsWorksheetDefinition } from "../us-fields";

export const US_RENAL: UsWorksheetDefinition = {
  examType: "us_renal",
  version: 1,
  indications: [
    option("right_flank_pain", "Right flank pain"),
    option("left_flank_pain", "Left flank pain"),
    option("hematuria", "Hematuria"),
    option("abdominal_pain", "Abdominal pain"),
    option("acute_kidney_injury", "Acute Kidney Injury"),
    option("urinary_retention", "Urinary retention"),
  ],
  sections: [
    {
      id: "kidney",
      label: "kidney",
      role: "findings",
      technicallyLimited: true,
      repeatPerSide: ["right", "left"],
      fields: KIDNEY_FINDINGS,
    },
    {
      id: "bladder",
      label: "Bladder",
      role: "findings",
      technicallyLimited: true,
      fields: RENAL_BLADDER_FINDINGS,
    },
    {
      id: "renal_impression",
      label: "Impression",
      role: "impression",
      fields: RENAL_IMPRESSION,
    },
  ],
  billing: {
    codes: [
      {
        cpt: "76775",
        label: "Renal/bladder ultrasound, limited",
        preTick: true,
      },
    ],
  },
};
